import { downloadCSV } from '@/lib/helpers';
import type { EmailRecipient, Recipient } from '../types';

/**
 * Export recipients to CSV file
 */
export function exportRecipientsToCSV(recipients: Recipient[], filename: string) {
    const headers = ['Full Name', 'Email', 'Subscription Status'];
    const rows = recipients.map(recipient => [recipient.name, recipient.email, recipient.status?.name || '']);

    downloadCSV({ filename, headers, rows });
}

/**
 * Export email recipients to CSV file
 */
export function exportEmailRecipientsToCSV(recipients: EmailRecipient[], filename: string) {
    const headers = ['Full Name', 'Email', 'Status'];
    const rows = recipients.map(recipient => [recipient.full_name, recipient.email, recipient.status]);

    downloadCSV({ filename, headers, rows });
}
